import React, { Component } from 'react'

import PlansSection from './PlansSection'
import ClubsSection from './ClubsSection'
import FaqSection from './FaqSection'

import '../../../../assets/sass/pages/landing/pricing/pricing.scss'

export default class Pricing extends Component {
    render() {
        return (
            <div className="pricing-page">
                {this.renderPlansSection()}
                {this.renderClubsSection()}
                {this.renderFaqSection()}
            </div>
        )
    }

    renderPlansSection() {
        return (
            <PlansSection />
        )
    }

    renderClubsSection() {
        const { clubs } = this.props;

        return (
            <ClubsSection clubs={clubs} />
        )
    }

    renderFaqSection() {
        const { questions } = this.props;

        return (
            <FaqSection questions={questions} />
        )
    }

    static defaultProps = {
        clubs: [
            {
                image: require('../../../../assets/img/demo/club-1.png'),
                name: 'Rome'
            },
            {
                image: require('../../../../assets/img/demo/club-2.png'),
                name: 'Derry City'
            },
            {
                image: require('../../../../assets/img/demo/club-3.png'),
                name: 'Cypress'
            },
            {
                image: require('../../../../assets/img/demo/club-4.png'),
                name: 'Barcelona'
            },
            {
                image: require('../../../../assets/img/demo/club-5.png'),
                name: 'Everton'
            },
        ],
        questions: [
            {
                question: 'Do I will be charged for selected plan after the trial period ends?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Can I upgrade the plan at anytime during the subscription period?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Do I will be charged for selected plan after the trial period ends?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Can I upgrade the plan at anytime during the subscription period?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Do I will be charged for selected plan after the trial period ends?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Can I upgrade the plan at anytime during the subscription period?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Do I will be charged for selected plan after the trial period ends?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
            {
                question: 'Can I upgrade the plan at anytime during the subscription period?',
                answer: [
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.',
                    'Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et.'
                ]
            },
        ]
    }
}
